<template>
  <div class="rounded-xl">
    <iframe
      v-if="item && item.provider.toUpperCase() === YOUTUBE"
      class="rounded-xl"
      :width="width"
      :height="height"
      :srcdoc="srcDoc(item,title)"
      :src="'https://www.youtube.com/embed/' + item.id"
      :title="title"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
    />
    <iframe
      v-else-if="item && item.provider.toUpperCase() === VIMEO"
      class="rounded-xl"
      :width="width"
      :height="height"
      :srcdoc="srcDoc(item,title)"
      :src="'https://player.vimeo.com/video/' + item.id"
      :title="title"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
    />
    <div v-else class="bg-bg-cart w-full h-[200px] flex items-center justify-center rounded-xl">
      <p class="text-label-text text-body-3-caption">
        {{ $t('placeholders.no_video') }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BasePlayerIframe',
  props: {
    title: {
      type: String,
      default: ''
    },
    item: {
      type: Object,
      default: () => {}
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '200'
    }
  },
  data () {
    return {
      YOUTUBE: 'YOUTUBE',
      VIMEO: 'VIMEO'
    }
  },
  methods: {
    srcDoc (item, title) {
      return `<style>
              *{padding:0;margin:0;overflow:hidden}
              html,body{height:100%}
              img,span{position:absolute;width:100%;top:0;bottom:0;margin:auto}
              span{height:1.5em;text-align:center;font:48px/1.5 sans-serif;color:white;text-shadow:0 0 0.5em black}
              </style>
              <a href=https://www.youtube.com/embed/${item.id}?autoplay=1>
              <img src=https://img.youtube.com/vi/${item.id}/hqdefault.jpg alt='${title}'><span>▶</span></a>`
    }
  }
}
</script>

<style scoped>

</style>
